import { createFileRoute } from '@tanstack/react-router'

import PoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/containers/PoktanPage'

export const Route = createFileRoute('/_backoffice/klb-petani/poktan/')({
  component: PoktanPage
})
